'use client';

import React from 'react';
import Typography from '@ui/Typography';
import Image from 'next/image';
import { formatNumberForLocale } from '@/utils/stringHelpers';
import { MdInfo } from 'react-icons/md';
import useInfoModalStore from '@/components/store/infoModalSlice';

const getDisplayAddress = (address) => {
  try {
    const { city, state, country } = JSON.parse(address);
    const location = [city, state, country].filter((item) => !!item);
    if (location.length > 0) {
      return location.join(', ');
    } else {
      return address;
    }
  } catch (e) {
    return address;
  }
};

function ProfileTitle(props) {
  const { company } = props;
  const { address } = company;

  const setShowInfoModal = useInfoModalStore((state) => state.setOpen);

  const handleShowInfo = () => {
    setShowInfoModal(true, {
      logoUrl: '/assets/images/neki-heart.png',
      title: 'Neki Score',
      name: 'Neki Score',
      description:
        'Your Neki Score reflects the total points your community members earn by taking meaningful action—giving, volunteering, engaging and celebrating goodness.',
    });
  };

  return (
    <div>
      <Typography variant="h2" component="h2">
        {company.name}
      </Typography>

      {/* <div className="flex flex-row gap-2">
        <Image
          className="text-text-secondary"
          src="/assets/images/neki-heart.png"
          alt="neki-score"
          width={28}
          height={24}
        />
        <Typography
          variant="subtitle1"
          color="textSecondary"
          className="line-clamp-1">
          Neki Score: {formatNumberForLocale(company?.points)}
        </Typography>

        <div
          className="flex items-center justify-center cursor-pointer"
          onClick={handleShowInfo}>
          <MdInfo className="h-5 w-5 text-text-disabled" />
        </div>
      </div> */}
      <Typography variant="subtitle2" color="textSecondary">
        {getDisplayAddress(address)}
      </Typography>

      {company?.website_url && (
        <div className="mt-4 flex gap-2 lg:mt-6">
          <Typography
            variant="hyperlink"
            component="a"
            target="_blank"
            href={company.website_url}>
            {company.website_url}
          </Typography>

          <object type="image/svg+xml" data="/assets/icons/weblink.svg" />
        </div>
      )}
    </div>
  );
}

export default ProfileTitle;
